import Et3Button from "../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import { SupervisorKhattabatDataStore } from "../../../../stores/supervisor-store/supervisor-khattabat-data-store";

const KhattabatDataForm = withLiteObserverAndTheme(() => {
  return (
    <Et3Button
      isEnabled={true}
      onClick={async () => {
        SupervisorKhattabatDataStore().getKhattabatDataCollection();
      }}
      size="LARGE"
      type="GET"
      text="GET_LATEST"
    />
  );
});
export default KhattabatDataForm;
